import React from 'react';

export const AppPadding: React.FC<any> = props => {
  return <div style={{ padding: 10 }}>{props.children}</div>;
};
